// Marketing events from our checkout to the e_g and EdgeTag scripts that public/index.html loads on the checkout
// pages (both are queue stubs until their libraries load, so calling them early is safe).

// The details step was accepted and the time is held: EdgeTag sends AddPaymentInfo + the customer's details
// (its listener is in the index.html template).
export function announceDetails({ firstName, lastName, email, phone, value }) {
  window.dispatchEvent(new CustomEvent('checkout-details', { detail: { firstName, lastName, email, phone, value, currency: 'USD' } }));
}

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const libLoaded = (part) => performance.getEntriesByType('resource').some((e) => e.name.includes(part));

// A paid order: Purchase to e_g and EdgeTag, once per order in this browser. Resolves when both libraries have had
// the chance to send it (at most ~6s), so a redirect right after doesn't drop the events.
export async function trackPurchase(p) {
  const key = `tracked_purchase_${p.transaction_id}`;
  try {
    if (localStorage.getItem(key)) return;
    localStorage.setItem(key, new Date().toISOString());
  } catch { /* storage blocked: still send once for this page view */ }
  for (let i = 0; i < 30 && !(window.e_g && window.edgetag); i += 1) await wait(100);   // the loader runs in <head>
  const contents = [{ id: p.product_id, quantity: p.quantity, item_price: p.value / (p.quantity || 1) }];
  if (window.e_g) {
    window.e_g('track', 'Purchase', {
      transaction_id: p.transaction_id, value: p.value, currency: p.currency, tax: 0,
      content_ids: contents.map((c) => c.id), contents, num_items: p.quantity, content_type: 'product_group',
      first_name: p.first_name, last_name: p.last_name, email_address: p.email, phone_number: p.phone,
    });
  }
  if (window.edgetag) {
    const user = { email: p.email, phone: (p.phone || '').replace(/\s+/g, ''), firstName: p.first_name, lastName: p.last_name };
    Object.keys(user).forEach((k) => { if (!user[k]) delete user[k]; });
    if (Object.keys(user).length) window.edgetag('data', user);
    window.edgetag('tag', 'Purchase', {
      orderId: p.transaction_id, value: p.value, currency: p.currency,
      contents: contents.map((c) => ({ ...c, title: p.product_name })),
    });
  }
  for (let i = 0; i < 50 && !(libLoaded('e.drshumardworkshop.com/e/') && libLoaded('duthc.drshumardworkshop.com/load')); i += 1) await wait(100);
  await wait(1000);   // let the libraries send what was queued
}
